"use client";

import Image from "next/image";
import { Icons, Images } from "@/app/assets/shared";
import TruncatedDescription from "@/components/TruncatedDescription";
import { useEffect, useState } from "react";

export default function PortfolioCard({ project, setSelectedPortfolio }: any) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const imageSrc = project?.newSliderBg || Images?.imagePlaceholder;
  return (
    <div
      key={`project-${project?.id || project?.title}`}
      className={`success-card col-span-1 flex flex-col justify-start cursor-pointer group ${project?.colspan === 1 ? "perspective-[1000px]" : ""}`}
      onClick={() => {
        setSelectedPortfolio(project?.id);
      }}
    >
      {" "}
      {mounted && (
        <div
          className="image-container relative overflow-hidden w-full 2xl:aspect-[1/1] aspect-[1/1] lg:aspect-[16/7] transition-transform duration-600 ease-in-out hover:rotate-y-[-6deg] hover:scale-[0.95]"
          style={{ transformStyle: "preserve-3d" }}
        >
          (
          <>
            <Image
              src={imageSrc}
              alt={project?.title || "portfolio"}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-600"
              fill
              sizes="(max-width: 1024px) 100vw, 50vw"
            />

            <div className="size-12 bottom-[20px] right-[20px] bg-white arrow-button absolute rounded-[100px] overflow-hidden flex transition-[transform,background-color] duration-600 ease-in-out group-hover:rotate-[-45deg] group-hover:bg-[#225BD4]">
              <Image
                className="size-[15px] arrow-button-img object-cover invert m-auto transition-[filter] duration-600 group-hover:invert-0"
                src={Icons?.arrowLeft}
                alt="arrow"
                width={15}
                height={15}
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
            </div>
          </>
          )
        </div>
      )}
      <h3 className="pt-[30px] pb-[10px] self-stretch justify-start text-white text-[length:var(--sucess-card-title)] font-medium clash-font capitalize leading-[110%]">
        {project?.title}
      </h3>
      <TruncatedDescription text={project?.description || ""} />
      <div className="tags-container flex flex-wrap lg:flex-nowrap gap-[10px] lg:gap-[2px] py-[15px]">
        {(project?.categories ?? [])?.map((cat: any, catIndex: number) => (
          <div
            key={`cat-${project?.id}-${cat?.name || cat}-${catIndex}`}
            className="tag-item flex items-center justify-center h-[54px] px-6 text-white font-medium text-center bg-[#FFFFFF14] rounded-2xl lg:rounded-none lg:first:rounded-l-full lg:first:pl-10 lg:last:rounded-r-full lg:last:pr-10"
          >
            {cat?.name || ""}
          </div>
        ))}
      </div>
    </div>
  );
}
